import styled from 'styled-components';

const StyledCheckbox = styled.div`
	padding-bottom: 15px;
	span {
		text-align: left;
		font-size: 15px;
		color: #ffffff;
	}
`;

export default StyledCheckbox;
